import * as React from "react";
import { FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { UserGender, UserGenderLabels } from "../../../data/constants";
import { GetTranslation } from "../../../translations/GetTranslation";
import { CustomAutocomplete } from "./CustomAutocomplete";
import { IBaseSelectProps } from "./IBaseSelectProps";
import { IOption } from "./IOption";

export const GenderSelect: FC<IBaseSelectProps<string, string | undefined>> = ({
  value,
  onChange = (_value?: string) => {},
  onBlur,
  ...props
}) => {
  const intl = useIntl();
  const [options, setOptions] = useState<IOption[]>([]);

  useEffect(() => {
    const genderOptions: IOption[] = Object.values(UserGender).map((gender) => ({
      value: gender,
      label: GetTranslation(intl, UserGenderLabels(gender)),
    }));
    setOptions(genderOptions);
  }, [intl]);

  const selectedOption = options.find((option) => option.value === value) || null;
  return (
    <CustomAutocomplete
      {...props}
      label={GetTranslation(intl, "person.field.gender")}
      options={options}
      getOptionLabel={(option) => option.label}
      value={selectedOption}
      onChange={(_event, value) => onChange(value?.value)}
      onBlur={onBlur}
    />
  );
};
